export const removeMappedSource = (mappedSources, sourceId) =>
  mappedSources.filter(
    (mappedSource) => sourceId !== mappedSource.knock_marketing_source_id
  );

export const removeIntegrationsMappedSource = (integrations, sourceId) =>
  integrations.map((integration) => {
    const mappedSources = integration.mapped_sources || [];
    if (mappedSources.length) {
      const updatedMappedSources = removeMappedSource(mappedSources, sourceId);
      return {
        ...integration,
        mapped_sources: updatedMappedSources,
      };
    }

    return integration;
  });

const formatInternationalPhoneNumber = (phoneNumber) =>
  `(${phoneNumber.substr(2, 3)}) ${phoneNumber.substr(
    5,
    3
  )}-${phoneNumber.substr(8, 4)}`;

export const getFormattedPhoneNumber = (phoneNumber) => {
  return phoneNumber?.startsWith('+')
    ? formatInternationalPhoneNumber(phoneNumber)
    : phoneNumber || '';
};

const payloadTrackingNumberCreationMap = {
  applicantForwardingNumber: 'applicant_forwarding_number',
  applicantGreetingDelaySeconds: 'applicant_greeting_delay_seconds',
  applicantGreetingRepeatCount: 'applicant_greeting_repeat_count',
  countryCode: 'country_code',
  greetingDelaySeconds: 'greeting_delay_seconds',
  greetingRepeatCount: 'greeting_repeat_count',
  residentGreetingDelaySeconds: 'resident_greeting_delay_seconds',
  residentGreetingRepeatCount: 'resident_greeting_repeat_count',
  shouldRecord: 'should_record',
  sourceId: 'source_id',
  voiceNumberRaw: 'relay_phone_number',
  voiceNumberForwardsToRaw: 'forwarding_phone_number',
  voiceNumberResidentForwardsToRaw: 'resident_forwarding_phone_number',
};

export const transformCreateRelayPhonePayload = (payload) =>
  Object.entries(payload).reduce((transformedPayload, [key, value]) => {
    const apiKey = payloadTrackingNumberCreationMap[key];
    transformedPayload[apiKey] = value;
    return transformedPayload;
  }, {});

const payloadTrackingNumberEditMap = {
  applicantForwardingNumber: 'applicant_forwarding_number',
  applicantGreetingDelaySeconds: 'applicant_greeting_delay_seconds',
  applicantGreetingRepeatCount: 'applicant_greeting_repeat_count',
  greetingDelaySeconds: 'greeting_delay_seconds',
  greetingRepeatCount: 'greeting_repeat_count',
  isSpamDetectionEnabled: 'is_spam_detection_enabled',
  residentGreetingDelaySeconds: 'resident_greeting_delay_seconds',
  residentGreetingRepeatCount: 'resident_greeting_repeat_count',
  shouldRecord: 'should_record',
  sourceId: 'source_id',
  voiceNumberForwardsToRaw: 'forwarding_number',
  voiceNumberResidentForwardsToRaw: 'resident_forwarding_number',
};

export const transformEditRelayPhonePayload = (payload) =>
  Object.entries(payload).reduce((transformedPayload, [key, value]) => {
    const apiKey = payloadTrackingNumberEditMap[key];
    transformedPayload[apiKey] = value;
    return transformedPayload;
  }, {});
